import React from 'react';
import styles from './CheckboxInput.module.css';

export interface CheckboxInputProps {
  id?: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
  name?: string;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  id,
  checked,
  onChange,
  disabled,
  className,
  label,
  name,
}) => {
  const containerClasses = `${styles.checkboxContainer} ${className || ''}`;

  return (
    <label htmlFor={id} className={containerClasses}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.checkboxInput}
      />
      {label && <span>{label}</span>}
    </label>
  );
};